export default __webpack_public_path__ + "static/media/landing.3a2b55dc.png";